import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { PSIDs } from '../../shared/interfaces/survey.interface';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'ps-ui-include-list',
  templateUrl: './include-list.component.html',
  styleUrls: ['./include-list.component.css'],
})
export class IncludeListComponent implements OnInit, OnDestroy {
  public includePsidsToDisplay: Array<PSIDs>;
  public psids: Array<PSIDs>;
  constructor(
    private _modalRef: ModalRef<
      IncludeListComponent,
      {
        surveyId: number;
        psids: Array<PSIDs>;
      }
    >,
    @Inject(ModalData)
    private _modalData: {
      psids: Array<PSIDs>;
    },
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.psids = this._modalData.psids;

    if (this.psids?.length) {
      this.includePsidsToDisplay = this.psids;
    }
    this._renderer.addClass(this._document.body, 'modal-open');
  }

  ngOnDestroy() {
    this._renderer.removeClass(this._document.body, 'modal-open');
  }
}
